import React from 'react';
import Link from 'react-router-dom/Link';

export default function Popup({ resetData }) {
  return (
    <div className="popup">
      <div className="popup__content">
        <div className="popup__header">
          <h1>Email sent</h1>
        </div>
        <div className="popup__body">
          <p>Check your inbox for more valuable pick ticket information.</p>
          <p>Thanks for taking the time to learn about the Pick Ticket Process!</p>
        </div>

        <div className="popup__footer">
          <Link
            to={{
              pathname: '/login',
              state: { prev: true },
            }}
            className="btn"
            onClick={resetData}
          >
            <span className="white-background">Exit</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
